import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=35c2c306&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35c2c306')) {
      api.createRecord('35c2c306', component.options)
    } else {
      api.reload('35c2c306', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=35c2c306&", function () {
      api.rerender('35c2c306', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-40w22Ntqpw978/JS/offershelp.vue"
export default component.exports